import type {
  Control,
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
} from 'react-hook-form'

import type {
  BillExtraChargeFormValue,
  BillLineItemFormValue,
} from '@/components/pages/Admin/BillManagement/Form/billLineItemsShared'
import type { BillBuyPartyType } from '@/constants/bill-buy-party'

export type BillFormGridVariant = 'default' | 'excel'

export const excelCellInputClass =
  'h-8 w-full rounded-none border-0 bg-transparent px-1.5 text-sm shadow-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary'

export const excelCellSelectTriggerClass =
  'h-8 w-full rounded-none border-0 bg-transparent px-1.5 text-sm shadow-none focus:ring-2 focus:ring-inset focus:ring-primary'

export type BillFormViewSharedProps = {
  control: Control<any>
  isCreate: boolean
  isLoading: boolean
  isBuyBill: boolean
  isWholesaleSell: boolean
  billTypeWatch: string
  buyPartyForLabels: BillBuyPartyType
  onBillTypeChange: (value: string) => void
  lineItemFields: FieldArrayWithId<any, 'line_items', 'id'>[]
  appendLineItem: UseFieldArrayAppend<any, 'line_items'>
  removeLineItem: UseFieldArrayRemove
  lineItems: BillLineItemFormValue[] | undefined
  syncWholesaleRowWeight: (rowIndex: number) => void
  extraChargeFields: FieldArrayWithId<any, 'bill_information.extra_charges', 'id'>[]
  appendExtraCharge: UseFieldArrayAppend<any, 'bill_information.extra_charges'>
  removeExtraCharge: UseFieldArrayRemove
  extraCharges: BillExtraChargeFormValue[] | undefined
  customerNameSuggestions: string[]
  profileLoading: boolean
  applyCustomerProfile: (name: string) => void | Promise<void>
  customerNameWatch: string
  totalKg: number
  subtotalBaht: number
  extraChargeTotal: number
  discountWatch: number
  isWholesaleSellSummary: boolean
  netBaht: number
  lineItemsErrorMessage?: string
  hasLineItemsError: boolean
}
